var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStars = function SvgStars(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 28,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 16.477c0-4.274 3.36-7.739 7.5-7.739-4.14 0-7.499-3.465-7.499-7.738 0 4.273-3.36 7.738-7.501 7.738 4.142 0 7.5 3.465 7.5 7.739Z",
    stroke: "#503B2D",
    strokeWidth: 0.915,
    fill: "#FDCD0B",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.103 9.875A7.28 7.28 0 0 1 16 8.738c-4.14 0-7.499-3.465-7.499-7.738A7.869 7.869 0 0 1 7.4 5.02c.75 2.286 2.488 4.08 4.703 4.855Z",
    fill: "#DAB20E",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 16.477c0-4.274 3.36-7.739 7.5-7.739-4.14 0-7.499-3.465-7.499-7.738 0 4.273-3.36 7.738-7.501 7.738 4.142 0 7.5 3.465 7.5 7.739Z",
    stroke: "#503B2D",
    strokeWidth: 0.915,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 17.714c0-2.563 2.015-4.643 4.5-4.643-2.485 0-4.5-2.078-4.5-4.642 0 2.564-2.014 4.642-4.5 4.642 2.485 0 4.5 2.08 4.5 4.643Z",
    stroke: "#503B2D",
    strokeWidth: 0.915,
    fill: "#FDCD0B",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.933 14.324A4.403 4.403 0 0 1 25 13.07c-2.485 0-4.5-2.078-4.5-4.642a4.7 4.7 0 0 1-1.214 3.164 4.579 4.579 0 0 0 2.647 2.73Z",
    fill: "#DAB20E",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 17.714c0-2.563 2.015-4.643 4.5-4.643-2.485 0-4.5-2.078-4.5-4.642 0 2.564-2.014 4.642-4.5 4.642 2.485 0 4.5 2.08 4.5 4.643Z",
    stroke: "#503B2D",
    strokeWidth: 0.915,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6 27c0-3.418 2.687-6.192 6-6.192-3.313.002-6-2.77-6-6.19 0 3.42-2.686 6.192-5.999 6.192 3.313 0 5.999 2.772 5.999 6.19Z",
    stroke: "#503B2D",
    strokeWidth: 0.915,
    fill: "#FDCD0B",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.084 21.991a5.843 5.843 0 0 1 3.515-1.183c-3.312.002-5.999-2.77-5.999-6.19 0 1.305-.4 2.576-1.146 3.63.607 1.745 1.938 3.118 3.63 3.743Z",
    fill: "#DAB20E",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6 27c0-3.418 2.687-6.192 6-6.192-3.313.002-6-2.77-6-6.19 0 3.42-2.686 6.192-5.999 6.192 3.313 0 5.999 2.772 5.999 6.19Z",
    stroke: "#503B2D",
    strokeWidth: 0.915,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
export default SvgStars;